import Icon from '../components/Icon.vue'

Icon.register({"window-minimize":{"width":1792,"height":1792,"paths":[{"d":"M1792 1312v192q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-192q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/window-minimize.js